/* "Nirvik Ready for learners" (/guides/learners): everything a learner does, in its own chapters. */
import welcome from './00-welcome.md?raw';
import signIn from './01-sign-in.md?raw';
import find from './02-find.md?raw';
import courses from './03-courses.md?raw';
import quizzes from './04-quizzes.md?raw';
import events from './05-events.md?raw';
import certificates from './06-certificates.md?raw';
import organizations from './07-organizations.md?raw';
import help from './08-help.md?raw';
import type { Guide } from '../types';

export const learnersGuide: Guide = {
  slug: 'learners',
  title: 'Nirvik Ready for learners',
  subtitle:
    'How to find, take and finish courses, quizzes and workshops, earn certificates and share them, on any phone and for free.',
  audiences: ['learners'],
  pdf: '/guides/learners/nirvik-ready-guide.pdf',
  reviewed: '2026-10-25',
  chapters: [
    {
      slug: 'welcome',
      title: 'Welcome to Nirvik Ready',
      summary: 'What it is and where to start',
      markdown: welcome,
    },
    {
      slug: 'sign-in',
      title: 'Sign in and set up',
      summary: 'Email codes, passkeys, your name and time zone',
      markdown: signIn,
    },
    {
      slug: 'find',
      title: 'Find something to learn',
      summary: 'Home, Explore and learning paths',
      markdown: find,
    },
    {
      slug: 'courses',
      title: 'Take a course',
      summary: 'Lessons, knowledge checks and the final assessment',
      markdown: courses,
    },
    {
      slug: 'quizzes',
      title: 'Quizzes and challenges',
      summary: 'Self-assessments, assessments and campaigns',
      markdown: quizzes,
    },
    {
      slug: 'events',
      title: 'Workshops and webinars',
      summary: 'Register, join, check in and get your certificate',
      markdown: events,
    },
    {
      slug: 'certificates',
      title: 'Your certificates',
      summary: 'Download, share, verify or keep private',
      markdown: certificates,
    },
    {
      slug: 'organizations',
      title: 'Your organizations',
      summary: 'Join with a code, and what your organization sees',
      markdown: organizations,
    },
    {
      slug: 'help',
      title: 'Get help',
      summary: 'Feedback, support requests and common questions',
      markdown: help,
    },
  ],
};
